import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Component, ElementRef, HostListener, OnInit, ViewChild, OnDestroy, AfterViewInit } from '@angular/core';
import { HomePageService } from './home-page.service';
import { slideElement } from './home-page-animations';
import { AppService } from './../app.service';

import SwiperCore, {
    Navigation,
    Scrollbar,
    Pagination,
    EffectFade,
    Swiper
} from 'swiper';
declare let $: any;

@Component({
    selector: 'app-home-page',
    templateUrl: './home-page.component.html',
    styleUrls: ['./home-page.component.scss'],
    animations: [slideElement]
})



export class HomePageComponent implements OnInit, AfterViewInit, OnDestroy {
    private screenWidth = window.innerWidth;
    private sectionToNavigateSubscription: Subscription;
    showTestDrive = false;
    showNewsletter = false;

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.screenWidth = event.target.innerWidth;
        this.checkWidth();
        // if (this.screenWidth < 993) {
        // SwiperCore.use([Navigation, Pagination, Scrollbar, EffectFade, Swiper]);

        // }
    }

    constructor(
        public homePageService: HomePageService,
        private appService: AppService
    ) {
        this.homePageService.isHomePage = true;
    }

    showForm() {
        const link = window.location.href;
        const testDrive = /jazda-probna/;
        const newsletter = /newsletter/;
        if (testDrive.test(link)) {
            setTimeout(() => {
                this.showTestDrive = true;
            }, 100);
        }
        if (newsletter.test(link)) {
            setTimeout(() => {
                this.showNewsletter = true;
            }, 100);
        }
    }

    ngOnInit() {
        this.checkWidth();
        if (this.screenWidth < 993) {
        SwiperCore.use([Navigation, Pagination, Scrollbar, EffectFade, Swiper]);

        }
    }

    ngAfterViewInit() {
        this.showForm();
    }

    ngOnDestroy() {
        this.sectionToNavigateSubscription.unsubscribe();
    }

    private checkWidth() {
        this.homePageService.isMobileDevice = this.screenWidth < 768;
    }

    goDown1() {
        // this.scroller.scrollToAnchor('annotation1');
        const input = document.getElementById('annotation1');
        if (input !== null) {
            const offsetTopMargin = 70;
            window.scroll({
              top: input.offsetTop - offsetTopMargin,
              behavior: 'smooth',
          });
        }
      }
      goDown2() {
        // this.scroller.scrollToAnchor('annotation2');
        const input = document.getElementById('annotation2');
        if (input !== null) {
            const offsetTopMargin = 70;
            window.scroll({
              top: input.offsetTop - offsetTopMargin,
              behavior: 'smooth',
          });
        }
      }
      goDown3() {
        // this.scroller.scrollToAnchor('annotation3');
        const input = document.getElementById('annotation3');
        if (input !== null) {
            const offsetTopMargin = 70;
            window.scroll({
              top: input.offsetTop - offsetTopMargin,
              behavior: 'smooth',
          });
        }
      }
      goDown4() {
        // this.scroller.scrollToAnchor('annotation3');
        const input = document.getElementById('annotation4');
        if (input !== null) {
            const offsetTopMargin = 70;
            window.scroll({
              top: input.offsetTop - offsetTopMargin,
              behavior: 'smooth',
          });
        }
      }

    scrollToform() {
        // const input = document.getElementById('inputFormOffer');
        // input.scrollIntoView({ behavior: "smooth", block: "start" });
        const input = document.getElementById('inputFormOffer');
        if (input !== null) {
            const offsetTopMargin = 70;
            window.scroll({
              top: input.offsetTop - offsetTopMargin,
              behavior: 'smooth',
          });
        }
    }

    scrollToform2() {
        // const input = document.getElementById('sectionOfferForm');
        // input.scrollIntoView({ behavior: "smooth", block: "start" })
        const input = document.getElementById('sectionOfferForm');
        if (input !== null) {
            const offsetTopMargin = 70;
            window.scroll({
              top: input.offsetTop - offsetTopMargin,
              behavior: 'smooth',
          });
        }
    }

    scrollToRaceSection() {
        const input = document.getElementById('sectionRace');
        if (input !== null) {
            const offsetTopMargin = 70;
            window.scroll({
              top: input.offsetTop - offsetTopMargin,
              behavior: 'smooth',
          });
        }
    }

    scrollToDescriptionSection() {
        const input = document.getElementById('sectionDescription');
        if (input !== null) {
            const offsetTopMargin = 70;
            window.scroll({
              top: input.offsetTop - offsetTopMargin,
              behavior: 'smooth',
          });
        }
    }

    scrollToEquipmentSection() {
        if (this.screenWidth < 993) {
            // const input = document.getElementById('sectionChange1');
            // input.scrollIntoView({ behavior: "smooth", block: "start" });
            const input = document.getElementById('sectionEquipmentMobile');
            if (input !== null) {
                const offsetTopMargin = 200;
                window.scroll({
                  top: input.offsetTop - offsetTopMargin,
                  behavior: 'smooth',
              });
            }
        } else if (this.screenWidth > 994 && this.screenWidth < 1920) {
            // const input = document.getElementById('sectionEquipmentDesktop');
            // input.scrollIntoView({ behavior: "smooth", block: "start" });
            const input = document.getElementById('sectionEquipmentDesktop');
            if (input !== null) {
                const offsetTopMargin = 250;
                window.scroll({
                  top: input.offsetTop - offsetTopMargin,
                  behavior: 'smooth',
              });
            }
        } else {
                        // const input = document.getElementById('sectionEquipmentDesktop');
            // input.scrollIntoView({ behavior: "smooth", block: "start" });
            const input = document.getElementById('sectionEquipmentDesktop');
            if (input !== null) {
                const offsetTopMargin = 330;
                window.scroll({
                  top: input.offsetTop - offsetTopMargin,
                  behavior: 'smooth',
              });
            }
        }
    }

    sendGaEvent(event, eventLabel, eventCategory) {
        this.appService.sendGaData(event, eventLabel, eventCategory);
    }

}
